import { Abacus } from "core/Abacus.Core";
import { Class } from "core/Abacus.Utilities";
import Swiper from "swiper";
import { SpinnerClass } from "core/classes/spinner.class";

let SwiperClassOptions = {
  swiperContainer: ".swiper-container",
  swiperDuplicate: "swiper-slide-duplicate",
  observer: true,
  swiper: {
    mode: "horizontal",
    speed: 500,
    loop: false,
    initialSlide: 0,
    simulateTouch: false,
    slideClass: "swiper-slide",
    noSwipingClass: "swiper-no-swiping",
    roundLengths: true
  }
};

class SwiperClass extends Class {
  constructor(element, mediator, options) {
    super();
    var self = this;
    this.setOptions(SwiperClassOptions, options);
    this.element = $(element);
    this.mediator = $(mediator);
    this.spinner = new SpinnerClass(this.element, {
      spinnerOptions: { color: "#000" }
    });
    this.preInit();
    this.swiper = new Swiper(
      this.element.find(this.options.swiperContainer)[0],
      this.options.swiper
    );
    setTimeout(function() {
      self.swiperLoaded();
    }, 0);
  }

  getSlides() {
    return $(this.element).find(
      this.options.swiperContainer + " ." + this.options.swiper.slideClass
    );
  }

  preInit() {
    if (!this.element.hasClass("loading")) this.element.addClass("loading");
    this.mediator.trigger("swiperPreInit", [
      this.element.find(this.options.swiperContainer)
    ]);
  }

  swiperLoaded() {
    var self = this;
    this.mediator.trigger("swiperLoaded", [self.element]);
    setTimeout(function() {
      self.element.removeClass("loading");
      self.element.addClass("loaded");
      self.spinner.hide();
    }, 500);
  }

  setMediaUrl(index) {
    var slideMedia = !this.initialLoad
      ? $(this.swiper.activeIndex).find("[data-media-url]")
      : $(this.getSlides().get(index)).find("[data-media-url]");
    if ($(slideMedia).attr("src") !== $(slideMedia).attr("data-media-url")) {
      $(slideMedia).attr("src", $(slideMedia).attr("data-media-url"));
    }
  }

  preload() {
    var index = this.getActiveIndex();
    var next = index + 1;
    var previous = index - 1;
    if (next < this.getSwiperSlides().length) this.preloadSlide(next);
    if (previous >= 0) this.preloadSlide(previous);
  }

  preloadSlide(index) {
    this.setMediaUrl(index);
  }

  addNoSwipeClass() {
    $(this.getSwiperSlides()).addClass(this.options.swiper.noSwipingClass);
  }

  previous() {
    this.swiper.slidePrev();
  }

  next() {
    this.swiper.slideNext();
  }

  goToSlide(index) {
    this.swiper.slideTo(index);
  }

  getActiveIndex() {
    return this.swiper.activeIndex;
  }

  getSwiperSlides() {
    return this.swiper.slides;
  }

  getSlide(index) {
    return this.swiper.activeIndex;
  }

  reInit() {
    this.swiper.observerUpdate();
  }

  startAutoplay() {
    this.swiper.autoplay.start();
  }

  stopAutoplay() {
    this.swiper.autoplay.stop();
  }
}

export { SwiperClass };



// WEBPACK FOOTER //
// ./Javascript/core/classes/swiper/swiper.class.js